<template>
  <!-- 信用批量申请页 -->
  <div class="credit-batch-application">
    <a-card class="card">
      <search-view
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button @click="exportTable" type="primary" class="margin-right-20">
          导出
        </a-button>
        <a-button @click="addTarget" type="primary" class="margin-right-20">
          新增自定义评分卡指标
        </a-button>
      </div>

      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
      >
        <template v-slot:action="{ tableRow }">
          <a-button
            type="link"
            size="small"
            @click="updateTarget(tableRow)"
            :disabled="tableRow.visible"
          >
            编辑
          </a-button>
          <a-button
            type="link"
            size="small"
            v-if="tableRow.dataType == 2"
            @click="setOption(tableRow)"
          >
            设置
          </a-button>
        </template>
      </table-view>

    </a-card>

    <a-modal
      v-model="addVisible"
      :title = 'maintenanceTitle'
      width=700px
      @ok="handleOk"
      @cancel="handleCancel"
      v-if="!numVisible"
    >
      <a-form :form="modalForm" style="margin-top: -10px">
        <div style="display: flex">
        <a-form-item label="指标类型">
          <!-- v-decorator="$decorator('targetType', '请选择指标类型')" -->
          <a-select v-model="modalForm.targetType" style="width: 300px" >
            <a-select-option 
              v-for="item in TARGET_TYPE_LIST"
              :key="item.value"
              @click="selectTitleType"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="指标分类" style="margin-left: 30px">
          <!-- v-decorator="$decorator('titleType', '请选择标题类型')" -->
          <a-select v-model="modalForm.titleType" style="width: 300px" v-if="modalForm.targetType == 5">
            <a-select-option v-for="item in TITLE_TYPE_LIST" :key="item.value" @click="refreshTitleType">
              {{ item.label }}
            </a-select-option>
          </a-select>
          <a-select v-model="modalForm.titleType" style="width: 300px" v-else>
            <a-select-option v-for="item in TITLE_TYPE_LISTS" :key="item.value" @click="refreshTitleType">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        </div>
        <div style="display: flex">
        <a-form-item label="指标名称" >
          <!-- v-decorator="$decorator('targetName', '请选择指标名称')" -->
          <a-input
            v-model="modalForm.targetName"
            style="width: 300px"
            />
        </a-form-item>
        <a-form-item label="指标字段" style="margin-left: 30px">
          <!-- v-decorator="$decorator('englishName', '请选择字段名称')" -->
          <a-input
            v-model="modalForm.englishName"
            style="width: 300px"
            />
        </a-form-item>
        </div>
        <a-form-item label="数据类型">
          <!-- v-decorator="$decorator('dataType', '请选择数据类型')" -->
          <a-select v-model="modalForm.dataType" style="width: 300px">
            <a-select-option 
              v-for="item in DATA_TYPE_LIST"
              :key="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model="addVisible"
      :title = 'maintenanceTitle'
      width=700px
      v-else
      footer
    >
      <a-form :form="modalForm" style="margin-top: -10px">
        <div style="display: flex">
        <a-form-item label="指标类型">
          <!-- v-decorator="$decorator('targetType', '请选择指标类型')" -->
          <a-select v-model="modalForm.targetType" style="width: 300px" :disabled="numVisible">
            <a-select-option 
              v-for="item in TARGET_TYPE_LIST"
              :key="item.value"
              @click="selectTitleType"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="指标分类" style="margin-left: 30px">
          <!-- v-decorator="$decorator('titleType', '请选择标题类型')" -->
          <a-select v-model="modalForm.titleType" style="width: 300px" v-if="modalForm.targetType == 5" :disabled="numVisible">
            <a-select-option v-for="item in TITLE_TYPE_LIST" :key="item.value" >
              {{ item.label }}
            </a-select-option>
          </a-select>
          <a-select v-model="modalForm.titleType" style="width: 300px" v-else :disabled="numVisible">
            <a-select-option v-for="item in TITLE_TYPE_LISTS" :key="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        </div>
        <div style="display: flex">
        <a-form-item label="指标名称" >
          <!-- v-decorator="$decorator('targetName', '请选择指标名称')" -->
          <a-input
            v-model="modalForm.targetName"
            style="width: 300px"
            :disabled="numVisible"
            />
        </a-form-item>
        <a-form-item label="指标字段" style="margin-left: 30px">
          <!-- v-decorator="$decorator('englishName', '请选择字段名称')" -->
          <a-input
            v-model="modalForm.englishName"
            style="width: 300px"
            :disabled="numVisible"
            />
        </a-form-item>
        </div>
        <a-form-item label="数据类型">
          <!-- v-decorator="$decorator('dataType', '请选择数据类型')" -->
          <a-select v-model="modalForm.dataType" style="width: 300px" :disabled="numVisible">
            <a-select-option 
              v-for="item in DATA_TYPE_LIST"
              :key="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="option"
      @ok="optionOk"
      @cancel="handleCancel"
      title="设置选项"
      :width="800"
      v-if="!numVisible"
    >
      <a-card >
        <a-row :gutter="20">
          <a-col>
            <div class="estimate-list" style="margin-top: -15px">
              <div class="estimate-question">
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="12" style="background: #f3f3f3">
                    <span style="margin-left: -30px">下拉选对应的键值</span>
                  </a-col>
                  <a-col :span="12" style="background: #f3f3f3">
                    <span style="margin-left: -30px">下拉选对应的键名</span>
                  </a-col>
                </a-row>
              </div>
              <div style="width: 140px; text-align: center; margin-left: -10px">
                <div style="width: 100%; background: #f3f3f3">操作</div>
              </div>
            </div>
            <div
              class="estimate-list"
              v-for="(item, index) in optionData"
              :key="index"
            >
              <div style="margin-right: 10px; margin-top: -15px">{{ index + 1 }}</div>
              <div class="estimate-question" >
                <div v-if="index == 0" style="height: 15px"> </div>
                <a-row :gutter="10">
                  <a-col :span="12">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input-number
                          controls-position="right"
                          v-model="item.value"
                          :min="0"
                          :max="9999"
                          style="width: 200px; height: 30px"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="12" label-width="0px">
                    <a-form-item>
                      <a-tooltip placement="topLeft">
                        <a-input
                          controls-position="right"
                          v-model="item.lable"
                          style="width: 200px; height: 30px"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="estimate-button">
                <a-tooltip placement="topLeft">
                  <template #title>新增</template>
                  <img
                    src="./images/add.png"
                    style="width: 20px; height: 20px"
                    @click="addOption"
                  />
                </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template #title>删除</template>
                  <img
                    src="./images/delete.png"
                    style="width: 20px; height: 20px"
                    @click="removeOption(item)"
                  />
                </a-tooltip>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </a-modal>

    <a-modal
      v-model="option"
      @cancel="handleCancel"
      footer
      title="设置选项"
      :width="800"
      v-else
    >
      <a-card >
        <a-row :gutter="20">
          <a-col>
            <div class="estimate-list" style="margin-top: -15px">
              <div class="estimate-question">
                <a-row :gutter="10" style="width: 100%; text-align: center">
                  <a-col :span="12" style="background: #f3f3f3">
                    <span style="margin-left: -30px">下拉选对应的键值</span>
                  </a-col>
                  <a-col :span="12" style="background: #f3f3f3">
                    <span style="margin-left: -30px">下拉选对应的键名</span>
                  </a-col>
                </a-row>
              </div>
              <div style="width: 140px; text-align: center; margin-left: -10px">
                <div style="width: 100%; background: #f3f3f3">操作</div>
              </div>
            </div>
            <div
              class="estimate-list"
              v-for="(item, index) in optionData"
              :key="index"
            >
              <div style="margin-right: 10px; margin-top: -15px">{{ index + 1 }}</div>
              <div class="estimate-question" >
                <div v-if="index == 0" style="height: 15px"> </div>
                <a-row :gutter="10">
                  <a-col :span="12">
                    <a-form-item label-width="0px">
                      <a-tooltip placement="topLeft">
                        <a-input-number
                          controls-position="right"
                          v-model="item.value"
                          :min="0"
                          :max="9999"
                          style="width: 200px; height: 30px"
                          :disabled="numVisible"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                  <a-col :span="12" label-width="0px">
                    <a-form-item>
                      <a-tooltip placement="topLeft">
                        <a-input
                          controls-position="right"
                          v-model="item.lable"
                          style="width: 200px; height: 30px"
                          :disabled="numVisible"
                        />
                      </a-tooltip>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="estimate-button" v-if="!numVisible">
                <a-tooltip placement="topLeft">
                  <template #title>新增</template>
                  <img
                    src="./images/add.png"
                    style="width: 20px; height: 20px"
                    @click="addOption"
                  />
                </a-tooltip>
                <a-tooltip placement="topLeft">
                  <template #title>删除</template>
                  <img
                    src="./images/delete.png"
                    style="width: 20px; height: 20px"
                    @click="removeOption(item)"
                  />
                </a-tooltip>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </a-modal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { TableView, SearchView } from 'lxfintech-fe'
import {
  exportLists,
  add,
  update,
  getTableData,
  getTableDatas,
  selectOption,
  addOptions,
  getTarget,
} from './api'
import { TITLE_TYPE_LIST, TARGET_TYPE_LIST, DATA_TYPE_LIST, TITLE_TYPE_LISTS } from './schema'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'custom-target-maintenance',
  data() {
    const initSearchForm = { targetTypeLabel: '', targetName: '', englishName: '' }
    const searchForm = cloneDeep(initSearchForm)
    return {
      initSearchForm,
      searchForm,
      tableData: [],
      chooseDatas: [],
      tableLoading: true,
      maintenanceTitle: '',
      addVisible: false,
      TITLE_TYPE_LIST, 
      TARGET_TYPE_LIST, 
      DATA_TYPE_LIST,
      TITLE_TYPE_LISTS,
      option: false,
      optionData: [],
      targetChooseId: '',
      numVisible: false,
      modalForm: {
        titleType: null,
        targetName: null,
        englishName: null,
        targetType: null,
        dataType: null,
      },
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          align: 'center',
        },
        {
          title: '指标类型',
          dataIndex: 'targetTypeLabel',
          align: 'center',
        },
        {
          title: '指标分类',
          dataIndex: 'titleTypeLabel',
          align: 'center',
        },
        {
          title: '指标名称',
          dataIndex: 'targetName',
          align: 'center',
        },
        {
          title: '指标字段',
          dataIndex: 'englishName',
          align: 'center',
        },
        {
          title: '数据类型',
          dataIndex: 'dataTypeLabel',
          align: 'center',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 140,
          align: 'center',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      searchSchema: [
        {
          label: '指标类型',
          type: 'select',
          itemName: 'targetTypeLabel',
          selectList: TARGET_TYPE_LIST.map(item => {
            return { value: item.label, text: item.label }
          }),
          allowClear: true,
        },
        {
          label: '指标名称',
          type: 'input',
          itemName: 'targetName',
          allowClear: true,
        },
        {
          label: '指标字段',
          type: 'input',
          itemName: 'englishName',
          allowClear: true,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  mounted() {
    // 评分卡指标
    this._getTableData(this.searchForm)
    this._getTableDatas()
    //this._getTableData(this.initSearchForm)
  },

  methods: {
    // 获取列表数据
    _getTableData(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
        let i = 0
        let j = 0
        for(; j<this.tableData.length; j++){
          if(this.tableData[j].targetType == 0){
            this.tableData[j].titleTypeLabel = '非财务指标'
          }else{
            for(i = 0; i<TITLE_TYPE_LIST.length; i++){
              if(TITLE_TYPE_LIST[i].value == this.tableData[j].titleType){
                this.tableData[j].titleTypeLabel = TITLE_TYPE_LIST[i].label
              }
            }
          }
          for(i = 0; i<TARGET_TYPE_LIST.length; i++){
            if(TARGET_TYPE_LIST[i].value == this.tableData[j].targetType){
              this.tableData[j].targetTypeLabel = TARGET_TYPE_LIST[i].label
            }
          }
          for(i = 0; i<DATA_TYPE_LIST.length; i++){
            if(DATA_TYPE_LIST[i].value == this.tableData[j].dataType){
              this.tableData[j].dataTypeLabel = DATA_TYPE_LIST[i].label
            }
          }
        }
      })
    },

    // 查询
    handleSearch(data) {
      this.searchForm = data
      this.pageData.current = 1
      if(data.titleType == '0'){
        data.targetType = 0
      }
      this._getTableData(data)
    },

  _getTableDatas(){
    getTableDatas().then(({ data }) => {
      this.chooseDatas = data
      let i = 0
      let j = 0
      for(; j<this.chooseDatas.length; j++){
        if(this.chooseDatas[j].targetType == 0){
          this.chooseDatas[j].titleTypeLabel = '非财务指标'
        }else{
          for(i = 0; i<TITLE_TYPE_LIST.length; i++){
            if(TITLE_TYPE_LIST[i].value == this.chooseDatas[j].titleType){
              this.chooseDatas[j].titleTypeLabel = TITLE_TYPE_LIST[i].label
            }
          }
        }
        for(i = 0; i<DATA_TYPE_LIST.length; i++){
          if(DATA_TYPE_LIST[i].value == this.chooseDatas[j].dataType){
            this.chooseDatas[j].dataTypeLabel = DATA_TYPE_LIST[i].label
          }
        }
      }
    })
  },

  selectTarget(id){
      getTarget(id).then(({data}) =>{
          let num = data
          if(num > 0){
            this.numVisible = true
          }else{
          this.numVisible = false
        }
      })
  },

    addTarget() {
      this.maintenanceTitle = '新增'
      this.numVisible = false
      this.modalForm = {}
      this.addVisible = true
    },

    updateTarget(tableRow) {
      this.selectTarget(tableRow.id)
      this.maintenanceTitle = '修改'
      this.modalForm.id = tableRow.id
      this.modalForm.titleType = tableRow.titleType 
      this.modalForm.targetName = tableRow.targetName   
      this.modalForm.englishName = tableRow.englishName  
      this.modalForm.targetType = tableRow.targetType   
      this.modalForm.dataType = tableRow.dataType 
      this.modalForm.whetherMust = tableRow.whetherMust
      this.addVisible = true
    },

    async handleOk(){
      if(this.modalForm.titleType == null || this.modalForm.targetName == null  || 
        this.modalForm.englishName == null || this.modalForm.targetType == null  || 
        this.modalForm.dataType == null){
        this.$notification.warning({
          message: '提示',
          description:
          '请填写完信息'
        })
        return false
      }
      if(this.modalForm.whetherMust == '' || this.modalForm.whetherMust == undefined){
        this.modalForm.whetherMust = 1
        const { message } = await add(this.modalForm)
        this.addVisible = false
        this.$notification.success({
          message: '提示',
          description: message,
        })
      }else if(this.modalForm.whetherMust == 1){
        const { message } = await update(this.modalForm)
        this.addVisible = false
        this.$notification.success({
          message: '提示',
          description: message,
        })
      }
      this._getTableData(this.searchForm)
    },

    handleCancel(){
      this.addVisible = false
      this.option = false
    },

    async exportTable() {
      try {
        const params = {
          chooseList: this.chooseDatas
        }
        exportLists(params)
      } catch (err) {
        console.log(err)
      }
    },

    selectTitleType(){
      this.modalForm.titleType = ''
    },

    refreshTitleType(){
      //点击强制刷新
        this.$forceUpdate()
    },

    setOption(tableRow){
      this.selectTarget(tableRow.id)
      this.targetChooseId = tableRow.id
      selectOption(tableRow.id).then(({ data }) => {
        this.goToSetting(data)
      })
      this.option = true
    },

    goToSetting(date) {
      this.optionData = []
      if (date.length > 0) {
        this.optionData = date
      } else {
        this.optionData.push(
        {
          value: null,
          lable: null,
        },
        {
          value: null,
          lable: null,
        },
        {
          value: null,
          lable: null,
        },
        ) 
      }   
    },

    // 新增一行
    addOption() {
      this.optionData.push({
        value: null,
        lable: null,
      })
    },
    // 删除一行
    removeOption(item) {
      let index = this.optionData.indexOf(item)
      if (index !== -1) {
        this.optionData.splice(index, 1)
      }
    },

    async optionOk(){
      for(let i = 0; i < this.optionData.length; i++){
        if(this.optionData[i].value == '' || this.optionData[i].value == undefined || 
            this.optionData[i].lable == '' || this.optionData[i].lable == undefined){
          this.$notification.warning({
              message: '提示',
              description: '请将信息填写完整',
            })
            return false
        }
      }
      const submitData = {
        targetChooseId: this.targetChooseId,
        chooseItemList: this.optionData,
      }
      const { message } = await addOptions(submitData)
      this.option = false
      this.$notification.success({
        message: '提示',
        description: message,
      })
    },
  },
  components: {
    TableView,
    SearchView,
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 10px;
  zoom: 1;
}

/deep/ .ant-form-explain {
  margin: 5px 0;
}

.estimate-list {
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.estimate-question {
  width: calc(100% - 140px);
}

.estimate-button {
  width: 50px;
  height: 40px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -17px;
}
</style>
